import { useEffect } from "react";
import { useNavigate } from "react-router";

import { isEnrolled, useApp } from "../state/store";
import { sayOn } from "./use-screen-status";

/**
 * Report how a sign-in went, then continue to wherever it unblocked.
 *
 * Boot and the `hashchange` listener both produce an outcome and neither can navigate --
 * they run outside React. This picks it up, routes on it once, and clears it.
 *
 * A device that has just signed in and has no template goes straight on to enrolment: that
 * is the next thing it needs, and stopping on an account screen to admire the result would
 * be a dead end. No status line there either -- the card at the top of
 * that screen already names the account, and saying it twice on one screen reads as a bug.
 *
 * Its own module, out of `app.tsx`, so the routing is tested in a memory router without the
 * app's browser router (`signin-outcome.test.tsx`).
 */
export function SignInOutcomeRouter() {
  const navigate = useNavigate();
  const outcome = useApp((s) => s.signInOutcome);

  useEffect(() => {
    if (!outcome) return;
    const state = useApp.getState();
    state.setSignInOutcome(null);
    if (outcome.kind === "ok" && state.account && !isEnrolled(state)) {
      navigate("/enroll", { replace: true });
      return;
    }
    const target = state.account ? "/account" : "/signin";
    if (outcome.message) sayOn(target, outcome.message, outcome.kind);
    navigate(target, { replace: true });
  }, [outcome, navigate]);

  return null;
}
